export default __webpack_public_path__ + "4bc79e12220c24f04bed124ece72e851.svg";